import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "row q-pa-sm" };
const _hoisted_4 = {
    key: 0,
    class: "col-12 col-md-6"
};
const _hoisted_5 = { class: "q-pa-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_BukenRoomList = _resolveComponent("BukenRoomList");
    const _component_KeiyakuInfoPanel = _resolveComponent("KeiyakuInfoPanel");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    { itemId: _ctx.PageID.keiyaku }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    (_ctx.myPageStore.isMultipleKeiyaku)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createVNode(_component_BukenRoomList)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_KeiyakuInfoPanel, { class: "col" })
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-5 col-md-3",
                                    label: "",
                                    color: "grey-8",
                                    onClick: _ctx.toTopPage
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.$q.screen.xs ? '' : 'row')
                                        }, [
                                            _createVNode(_component_q_icon, {
                                                class: _normalizeClass(_ctx.$q.screen.xs ? '' : 'on-left'),
                                                name: "navigate_before"
                                            }, null, 8, ["class"]),
                                            _cache[0] || (_cache[0] = _createElementVNode("div", null, "トップに戻る", -1))
                                        ], 2)
                                    ]),
                                    _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-5 col-md-3 no-wrap",
                                    color: "green-7",
                                    onClick: _ctx.toEditPage
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.$q.screen.xs ? '' : 'row')
                                        }, [
                                            (_ctx.$q.screen.xs)
                                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                                    key: 0,
                                                    name: "navigate_next"
                                                }))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", null, _toDisplayString(_ctx.$q.screen.xs ? '契約内容詳細' : '契約内容詳細の編集'), 1),
                                            (!_ctx.$q.screen.xs)
                                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                                    key: 1,
                                                    class: "on-right",
                                                    name: "navigate_next"
                                                }))
                                                : _createCommentVNode("", true)
                                        ], 2)
                                    ]),
                                    _: 1
                                }, 8, ["onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
